import React, { useState, useEffect } from "react";
import { Paper, Text, Title, Grid, Badge, Button, Group, Modal, Alert } from "@mantine/core";
import { djangoAxiosInstance } from "../../../api";

const SubscriptionSection = ({ subscription }) => {
  const [subscriptionState, setSubscriptionState] = useState(subscription);
  const [cancelModalOpened, setCancelModalOpened] = useState(false);
  const [cancelStatus, setCancelStatus] = useState({
    success: null,
    message: "Are you sure you want to cancel this subscription? This action cannot be undone."
  });

  useEffect(() => {
    setSubscriptionState(subscription);
  }, [subscription]);

  const isSubscriptionActive = subscriptionState.status === "active";
  
  if (!subscriptionState) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const handleCancelSubscription = async () => {
    try {
      const accessToken = localStorage.getItem("access_token");
      const headers = {};
      if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }

      const response = await djangoAxiosInstance.delete(
        `/subscriptions/${subscriptionState.id}/`,
        { headers }
      );

      console.log("response: ", response);

      if (response.status === 204) {
        setCancelStatus({
          success: true,
          message: "Subscription was successfully cancelled."
        });
        
        setSubscriptionState({
          ...subscriptionState,
          status: "canceled"
        });

      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {
      console.error("Error cancelling subscription:", err);

      setCancelStatus({
        success: false,
        message:
          err.response?.data?.message ||
          "Failed to cancel subscription. Please try again."
      });
    }
  };

  return (
    <Paper shadow="md" p="md" withBorder mt="md">
      <Group justify="space-between" mb="md">
        <Title order={2}>Subscription Details</Title>
        {isSubscriptionActive && (
          <Button 
          color="red" 
          variant="outline" 
          onClick={() => {
            setCancelStatus({
              success: null,
              message: "Are you sure you want to cancel this subscription? This action cannot be undone."
            });
            setCancelModalOpened(true);
          }}
        >
          Cancel Subscription
        </Button>
        )}
      </Group>
      
      <Grid>
        <Grid.Col span={6}>
          <Text fw={500}>Subscription ID</Text>
          <Text>{subscriptionState.id}</Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Text fw={500}>Plan Type</Text>
          <Badge color="blue">{subscriptionState.plan_type}</Badge>
        </Grid.Col>
        <Grid.Col span={6}>
          <Text fw={500}>End Date</Text>
          <Text>{formatDate(subscriptionState.end_date)}</Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Text fw={500}>Seats</Text>
          <Text>
            {subscriptionState.subscription_seats.length} / {subscriptionState.seat_limit}{" "}
            used
          </Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Text fw={500}>Status</Text>
          <Badge color={isSubscriptionActive ? "green" : "gray"}>
            {subscriptionState.status}
          </Badge>
        </Grid.Col>
      </Grid>

      <Modal
        opened={cancelModalOpened}
        onClose={() => setCancelModalOpened(false)}
        title={cancelStatus.success === null ? "Cancel subscription" : cancelStatus.success ? "Success" : "Error"}
        centered
      >
        <Alert
          color={cancelStatus.success === null ? "blue" : cancelStatus.success ? "green" : "red"}
          title={cancelStatus.success === null ? "Confirm" : cancelStatus.success ? "Success" : "Error"}
          mb="md"
        >
          {cancelStatus.message}
        </Alert>

        <Group mt="md" justify="space-between">
          {cancelStatus.success === null ? (
            <>
              <Button variant="outline" onClick={() => setCancelModalOpened(false)}>
                Cancel
              </Button>
              <Button color="red" onClick={handleCancelSubscription}>
                Yes, cancel subscription
              </Button>
            </>
          ) : (
            <Button onClick={() => setCancelModalOpened(false)}>Close</Button>
          )}
        </Group>
      </Modal>
    </Paper>
  );
};

export default SubscriptionSection;